module.exports = __webpack_public_path__ + "img/41.14f86d03.jpg";